class ErrorDetails {
  public source: string;
  public message: string;
  public correlationId?: string;
  public stacktrace?: string;
  constructor(
    source: string,
    message: string,
    correlationId?: string,
    stacktrace?: string
  ) {
    this.source = source;
    this.message = message;
    this.correlationId = correlationId;
    this.stacktrace = stacktrace;
  }
}
export { ErrorDetails };
